import { QueryTableApiView } from "@/components/query-table/views/QueryTableApiView";
import { QueryTableSelectedOnlyView } from "@/components/query-table/views/QueryTableSelectedOnlyView";
import { dataTableOnlySelectedViewModes } from "@/types/dataTableSettings";
import {
  QueryTableProps,
  useMergedListFeatures,
} from "@/components/query-table/QueryTable.shared";
import { QueryTableContent } from "./components/QueryTableContent";
import { QueryTableDirtyRowsStatus } from "./components/QueryTableDirtyRowsStatus";
import { QueryTableHeader } from "./components/QueryTableHeader";
import { QueryTableMenubar } from "./components/QueryTableMenubar";
import { QueryTableSelectedRowsStatus } from "./components/QueryTableSelectedRowsStatus";
import { QueryTableStatus } from "./components/QueryTableStatus";

export type { QueryTableProps };
export type ListProps<T> = QueryTableProps<T>;

export const QueryTable = <T extends { id: string }>({
  tableFeatures,
  ...rest
}: QueryTableProps<T>) => {
  const tableFeaturesMerged = useMergedListFeatures(tableFeatures);

  const showOnlySelectedView = Boolean(
    tableFeaturesMerged.enableOnlySelectedFilter &&
      tableFeaturesMerged.enableRowSelection &&
      tableFeaturesMerged.onlySelectedViewMode ===
        dataTableOnlySelectedViewModes.selected,
  );

  if (showOnlySelectedView) {
    return (
      <QueryTableSelectedOnlyView<T>
        listProps={{ ...rest, tableFeatures }}
        tableFeaturesMerged={tableFeaturesMerged}
      />
    );
  }

  return (
    <QueryTableApiView<T>
      listProps={{ ...rest, tableFeatures }}
      tableFeaturesMerged={tableFeaturesMerged}
    />
  );
};

QueryTable.Header = QueryTableHeader;
QueryTable.Menubar = QueryTableMenubar;
QueryTable.Content = QueryTableContent;
QueryTable.Status = QueryTableStatus;
QueryTable.DirtyRowsStatus = QueryTableDirtyRowsStatus;
QueryTable.SelectedRowsStatus = QueryTableSelectedRowsStatus;

QueryTable.displayName = "QueryTable";
